import { addStyles, DefaultTheme } from '../theme';

export const CSS = {
	container: 'c-Accordion',
	header: 'c-Accordion__header',
	subtitle: 'c-Accordion__subtitle',
	body: 'c-Accordion__body',
};

addStyles({
	[CSS.container]: {
		border: '1px solid #ccc',
		'border-radius': '4px',
		overflow: 'hidden',
	},
	[CSS.header]: {
		cursor: 'pointer',
		padding: DefaultTheme.space(3),
		'font-weight': 'bold',
		'font-size': '115%',
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(2),
		'user-select': 'none',
		'list-style': 'none',
		'&::-webkit-details-marker': {
			display: 'none',
		},
		'&:hover': {
			background: DefaultTheme.background.lightGrey,
		},
		'&::after': {
			content: '""',
			display: 'inline-block',
			width: '8px',
			height: '8px',
			'border-right': '2px solid currentColor',
			'border-bottom': '2px solid currentColor',
			transform: 'rotate(45deg)',
			transition: 'transform 0.2s ease',
			'flex-shrink': 0,
			'margin-right': DefaultTheme.space(1),
		},
		'& > span': {
			flex: '1',
			display: 'inline-flex',
			'align-items': 'center',
		},
	},
	[`${CSS.container}[open] > .${CSS.header}::after`]: {
		transform: 'rotate(-135deg)',
		'margin-bottom': '-4px',
	},
	[`${CSS.header} .${CSS.subtitle}`]: {
		'font-size': '0.9em',
		'margin-left': '8px',
		opacity: '0.7',
		'vertical-align': 'middle',
	},
	[CSS.body]: {
		padding: DefaultTheme.space(3),
		'border-top': '1px solid #ccc',
	},
});
